// Promise.withResolvers polyfill.
//
// pdfjs-dist 4+ (pulled in by react-pdf 8+) calls Promise.withResolvers. It is a
// standardized ES2024 API, native in Chrome 119+/Firefox 121+/Safari 17.4+ and
// Node 22+, but ABSENT in Node 20 (our CI/build/test runtime) and older browsers.
// Importing this first — from the app entry (src/index.js) and the vitest setup —
// guarantees the global exists before any react-pdf/pdfjs code runs.

// The API is not present in our TS lib target (ES2020), so declare it here.
interface PromiseWithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
}

declare global {
  interface PromiseConstructor {
    withResolvers?: <T>() => PromiseWithResolvers<T>;
  }
}

if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function withResolvers<T>(): PromiseWithResolvers<T> {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export {};
